import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import React from 'react';

interface PageProps {
  title: string;
  subtitle?: string;
  action?: JSX.Element;
  children: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
  },
  children: {
    marginTop: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));

export default function Page({
  title,
  subtitle,
  action,
  children,
}: PageProps) {
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={action ? 9 : 12}>
          <Typography variant="h2" component="h1">{title}</Typography>
          {subtitle && <Typography variant="h4" component="h2">{subtitle}</Typography>}
        </Grid>
        {action && (
          <Grid item xs={3} className={classes.actions}>
            {action}
          </Grid>
        )}
      </Grid>
      <Box className={classes.children}>{children}</Box>
    </Container>
  );
}
